export enum PlanningSegmentRuleMode {
  NONE = "NONE",
  INCLUDE = "INCLUDE",
  EXCLUDE = "EXCLUDE"
}
